<template>
<div>
    <b-modal
        no-close-on-backdrop
        centered
        ok-only
        size="lg"
        hide-footer
        title="Analisar Cupom"
        v-model="open"
    >
        <h1 class="title font-weight-bold text-uppercase">CUPOM:
            <span class="c-orange">{{ dataCouponInformations.couponName }}</span>
        </h1>
        <br>
        <PeriodsFilters
            ref="periodsFilters"
            :setDatesAutomatic="false"
            :startDate.sync="period.startDate"
            :endDate.sync="period.endDate"
            @click.native="get()"
        />        

        <b-col cols="12">
            <h2 class="mt-5 title font-weight-bold text-uppercase text-center mb-5">
                Clientes que Usaram o Cupom
            </h2>
            <span><strong>Total de cupons usados:</strong> 
                {{ quantityCoupon }}
            </span> <br>
            
            <span><strong>Total de usos por cliente:</strong> 
                {{ sameUsers.length }}
            </span>
        </b-col>

        <b-col cols="12">
            <b-table
                striped
                hover
                responsive
                show-empty
                empty-text="Esse cupom não possui usos"
                :fields="table.headers"
                :items="table.records"
                :busy="loading"
            >
                <template #cell(date)="data">
                    {{ formatDate(data.item.dateCreated) }}
                </template>
                <template #cell(firstName)="data">
                    {{ data.item.firstName }}
                </template>
                <template #cell(visualize)="data">
                    <b-button
                        class="ml-5"
                        :title="`Detalhes do pedido de ${data.item.firstName}`"
                        variant="warning"
                        @click="$refs.orderDetails.toggleOpen({
                            orderId: data.item.userId,
                            uuid: data.item.uuid,
                            dataModal: data.item
                        })"
                    >
                        <i class="fas fa-eye"></i>
                    </b-button>                        
                </template>
            </b-table>
        </b-col>
    </b-modal>    

    <OrderDetails
        ref="orderDetails"
    />
    
</div>
</template>

<script>
import { mapActions } from 'vuex';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import OrderDetails from '@/components/Order/OrderDetails.vue';

export default {
    name: 'ModalViewCoupon',
    components: {
        PeriodsFilters,
        OrderDetails
    },

    data() {
        return {
            open: false,
            loading: false,
            dataInformations: [],
            sameUsers: [],
            quantityCoupon: 0,
            dataCouponInformations: {
                couponName: '',
                idCoupon: 0
            },
            test: {
                status: 1,
                paymentType: 'pix',
                id: 3007,
                delivery: 'delivery'
            },
            dataClients: [],
            payments: [],
            period: {
                startDate: '',
                endDate: '',
            },
            table: {
                headers: [
                    {
                        key: 'date',
                        label: 'Data',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'firstName',
                        label: 'Nome do cliente',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'visualize',
                        label: 'Ver detalhes do pedido',
                        sortable: false
                    },
                ],
                records: []
            },
    }
    },

    methods: {
        ...mapActions('shopkeeper', ['getOrderDetails', 'cathUserCoupon',]),
        toggleOpen(data = []) {
            this.open = !this.open;
            this.dataCouponInformations.couponName = data.data.coupon;
            this.dataCouponInformations.idCoupon = data.data.id;
            this.get();
        },

        async get() {
            const { startDate, endDate } = this.period;
            try {
                const resp = await this.cathUserCoupon({
                        couponId: this.dataCouponInformations.idCoupon,
                        startDate: startDate,
                        endDate: endDate
                });
                this.table.records = resp.data || [];
                this.quantityCoupon = resp.data.length;

                resp.data.forEach((element, index) => {
                    this.dataClients = element;
                    if (index == 0) {
                        this.sameUsers.push(element.userId);
                    } 
                    const isUser = this.sameUsers.some((id) => element.userId == id);
                    if (!isUser) this.sameUsers.push(element.userId);
                });
            } catch (error) {
                this.makeToast(
                    'Erro',
                    'Houve um erro ao trazer os dados dos clientes',
                    'danger'
                );
            } finally {
                this.loading = false;
            }
        },

        formatDate(value) {
            return new Date(value).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        }
    }
}
</script>
<style scoped>
.list-style-clients {
    border: solid, 2px, black;
    list-style: none;
}
</style>